export default __webpack_public_path__ + "static/classic_games-68e2b254814f7a259856d8cd4e801e31.jpg";